import { render, staticRenderFns } from "./COrderValidation.vue?vue&type=template&id=4553a872&"
import script from "./COrderValidation.vue?vue&type=script&lang=js&"
export * from "./COrderValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports